// Step 7c · E3 — the "effect event" pattern (React's useEffectEvent, which is not stable in React 19.0).
// useEffectEvent(fn) returns ONE function that stays the same for the component's whole life and always calls the
// latest fn. Use it when an effect must run only when its own listed values change (an engagement switch, a dialog
// opening, a filter) while the work it starts reads other values that are newer (t, props, other state):
//
//   const loadOnChange = useEffectEvent(load);
//   useEffect(() => { loadOnChange(); }, [currentEngId, loadOnChange]);   // runs on an engagement switch only, as before
//
// Listing the returned function in the dependency list never re-runs the effect (it never changes), so the effect
// fires exactly when it did before, with nothing hidden from react-hooks/exhaustive-deps.
import { useCallback, useLayoutEffect, useRef } from "react";

export default function useEffectEvent(fn) {
  const ref = useRef(fn);
  // the layout effect runs before every passive effect of the same commit, so an effect always calls this render's fn
  useLayoutEffect(() => { ref.current = fn; });
  return useCallback((...args) => ref.current(...args), []);
}
